// src/components/layout/BottomNav.js
import React from 'react';
import { Home, Video, Calendar, Headphones, MoreHorizontal } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const BottomNav = () => {

    const location = useLocation();
    const pathname = location.pathname;

    const navigate = useNavigate()
    const tabs = [
        { id: 'home', icon: Home, label: 'Home', path: '/home' },
        { id: 'cctv', icon: Video, label: 'CCTV', path: '/cctv' },
        { id: 'schedule', icon: Calendar, label: 'Schedule', path: '/schedule' },
        { id: 'support', icon: Headphones, label: 'Support', path: '/support' },
        { id: 'more', icon: MoreHorizontal, label: 'More', path: '/more' },
    ];


    const getActiveTab = () => {
        const matching = tabs.find(t => pathname.startsWith(t.path));
        return matching ? matching.id : 'home';
    };

    const activeTab = getActiveTab();
    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t">
            <div className="flex justify-around items-center h-16">
                {tabs.map((tab) => {
                    const isActive = activeTab === tab.id;
                    return (

                        <button
                            key={tab.id}
                            onClick={() => {
                                navigate('/' + tab.id)
                            }}
                            className={`flex flex-col items-center justify-center space-y-1 flex-1 h-full transition ${isActive ? 'text-cyan-500' : 'text-gray-400'
                                }`}
                        >
                            <tab.icon className="w-6 h-6" />
                            <span className="text-xs font-medium">{tab.label}</span>
                        </button>
                    )
                })}
            </div>
        </div>
    );
};

export default BottomNav;